<template>
  <v-card :flat="isEmbeddedPage" :class="{ 'settings-card': isEmbeddedPage }">
    <v-container>
      <v-card-title v-if="isEmbeddedPage" class="settings-header-text"
        >{{ formTitle }} {{ title ? title : listType.name }}</v-card-title
      >
      <v-card-title v-if="!isEmbeddedPage">
        <span class="headline">{{
          title ? title : `${formTitle} ${listType.name}`
        }}</span>
        <v-spacer></v-spacer>
        <v-btn v-if="!isEmbeddedPage" text icon color="grey" @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-sheet v-if="subtitle" class="settings-section-main-content">
        {{ subtitle }}
      </v-sheet>

      <v-card-text class="px-md-0">
        <v-container class="settings-section-main-content">
          <v-form ref="form" v-model="formValid" @submit.prevent="saveWrapper">
            <v-row>
              <v-col cols="12" v-if="!isEmbeddedPage">
                <v-text-field
                  v-if="
                    ![
                      'forwarding_number',
                      'call_tracking_number',
                      'phone_blocklist'
                    ].includes(listType.code)
                  "
                  autofocus
                  outlined
                  v-model="editedItem.name"
                  required
                  :rules="[rules.required]"
                  label="Name"
                  placeholder="Name"
                ></v-text-field>
                <v-text-field
                  v-if="
                    [
                      'forwarding_number',
                      'call_tracking_number',
                      'phone_blocklist'
                    ].includes(listType.code)
                  "
                  autofocus
                  outlined
                  hint="e.g. (555) 555-1212"
                  v-mask="masks.phone"
                  v-model="editedItem.name"
                  required
                  :rules="[rules.required]"
                  label="Name"
                  placeholder="Name"
                ></v-text-field>
              </v-col>
              <v-col cols="12" v-if="['msg_template'].includes(listType.code)">
                <v-textarea
                  autofocus
                  outlined
                  v-model="editedItem.meta.value"
                  required
                  :rules="[rules.required]"
                  auto-grow
                  full-width
                  label="Value"
                  placeholder="Value"
                  counter="160"
                  :hint="
                    ['msg_template'].includes(listType.code)
                      ? 'Use the following merge field to add a review link: ' +
                        REPLACE_WITH_REVIEW_LINK
                      : ''
                  "
                  persistent-hint
                ></v-textarea>
              </v-col>
              <v-col cols="12" v-if="['job_type'].includes(listType.code)">
                <v-menu
                  ref="colorPicker"
                  origin="center center"
                  transition="scale-transition"
                  z-index="1500"
                  persistent
                  max-width="320"
                  open-on-click
                  close-on-content-click
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      autocomplete="off"
                      outlined
                      z-index="1501"
                      v-on="on"
                      v-model="editedItem.meta.color"
                      required
                      :rules="[rules.required]"
                      label="Color"
                      placeholder="Color"
                    ></v-text-field>
                    <div class="v-color-picker__color sample-color">
                      <div
                        v-on="on"
                        :style="{ background: editedItem.meta.color }"
                        width="200"
                      ></div>
                    </div>
                  </template>
                  <v-card class="ma-auto" flat>
                    <v-color-picker
                      class="ma-2 color-picker"
                      flat
                      mode="hexa"
                      hide-mode-switch
                      show-swatches
                      :value="editedItem.meta.color"
                      @input="changeEditedItemColor($event)"
                      swatches-max-height="250px"
                    ></v-color-picker>
                  </v-card>
                </v-menu>
              </v-col>
            </v-row>
            <v-row v-if="['msg_template'].includes(listType.code)">
              <v-col cols="12" class="px-0">
                <v-card-title>Preview</v-card-title>
                <div class="msg-detail-container row">
                  <message-content-bubble
                    :historyItem="testReviewRequestMessage"
                    customerName="Test Company"
                  ></message-content-bubble>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions class="mr-2 mr-md-0 mb-8">
        <v-spacer></v-spacer>
        <v-btn
          v-if="!isEmbeddedPage"
          color="blue darken-1"
          class="px-8"
          :disabled="!hasChangeToItemValue"
          text
          @click="saveWrapper"
          >Save</v-btn
        >
        <v-btn
          v-if="isEmbeddedPage"
          color="primary"
          class="px-8"
          :disabled="!hasChangeToItemValue"
          @click="saveWrapper"
          >Save</v-btn
        >
      </v-card-actions>
    </v-container>
  </v-card>
</template>

<script>
import ListItem from "../../../models/ListItem";
import { REPLACE_WITH_REVIEW_LINK } from "../../../globalVars";
const MessageContentBubble = () =>
  import(
    /* webpackChunkName: "components-customers-history-MessageContentBubble" */ `../../customers/history/MessageContentBubble.vue`
  );
import { VALIDATION_RULES } from "../../../helpers/ValidationRules";
import Message from "../../../models/Message";
import { MASKS } from "../../../helpers/Masks";
import { mask } from "vue-the-mask";

export default {
  name: "ListTypeFieldEditor",
  components: {
    MessageContentBubble
  },
  directives: {
    mask
  },
  props: {
    // EditItemFunction: {
    //   type: Function,
    //   required: false
    // },
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    listTypeId: {
      type: Number,
      required: true
    },
    listType: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    onClose: {
      type: Function,
      required: false
    },
    onSave: {
      type: Function,
      required: false
    }
  },
  data: function() {
    return {
      REPLACE_WITH_REVIEW_LINK,
      formValid: true,
      editedItem: new ListItem(),

      masks: MASKS,
      rules: VALIDATION_RULES,

      genericRequestUrl: null
    };
  },
  created() {
    this.editedItem = JSON.parse(JSON.stringify(this.item));
    this.editedItem.isDirty = true;
    this.getReviewLink();
  },
  computed: {
    isEmbeddedPage() {
      return !this.onClose;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
    hasChangeToItemValue() {
      return this.editedItem.meta.value != this.item.meta.value;
    },
    testReviewRequestMessage() {
      let testMessage = new Message();
      testMessage.isInbound = false;
      testMessage.user = this.user;
      testMessage.createdAt = new Date();
      testMessage.updatedAt = new Date();
      testMessage.messageBody = this.editedItem.meta.value;
      if (this.genericRequestUrl) {
        testMessage.messageBody = testMessage.messageBody.replace(
          "{{REQUEST_REVIEW_LINK}}",
          this.genericRequestUrl
        );
      }
      return testMessage;
    }
  },
  methods: {
    changeEditedItemColor(color) {
      if (typeof color == "object" && color.hexa) {
        this.editedItem.meta.color = color.hexa.substring(0, 7);
      } else {
        this.editedItem.meta.color = color.substring(0, 7);
      }
    },
    saveWrapper() {
      if (this.$refs.form.validate()) {
        if (!this.isEmbeddedPage) {
          this.onSave();
        } else {
          this.onSave(this.editedItem);
        }
      }
    },
    async getReviewLink() {
      let response = await this.$store.dispatch(
        "entities/redirectLink/getRedirectLink",
        {
          customerId: null
        }
      );
      if (response && response.url) {
        this.genericRequestUrl = response.url;
      }
    }
  },
  watch: {}
};
</script>

<style scoped lang="stylus">
div.spacer {
  width: 3rem;
}
div.sample-color {
  width: 90%;
  max-height: 2rem !important;
  height: 2rem !important;
}
div.v-menu__content {
  background-color: white;
}
</style>
